import React from 'react';
import {
  Typography,
  Button,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';

const ApiDocumentationCardComponent = () => (
  <Card id="documentation-card-container">
    <CardHeader
      title={<h4 style={{ color: 'black' }}>Events API Documentation</h4>}
      subheader="Utilize the Pingum APIs to interact with Events from your own System or Application"
    />
    <CardContent>
      <Typography variant="h5" gutterBottom>
        View Full API Docs Here:
        <a
          href={`${window.location.origin}/docs/api`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {` ${window.location.origin}/docs/api`}
        </a>
      </Typography>
      <div>
        <Typography gutterBottom>
          Docs
        </Typography>
        <Typography variant="caption" gutterBottom>
          {`
            The Pingum API Docs will provide you and your development team with the available
            restful endpoints by which you can interact with Pingum from your system. Each endpoint
            outlines the URL to invoke, the required Headers to set, and any Request Body items that
            are needed.
          `}
        </Typography>
        <div style={{ textAlign: 'center' }}>
          <Button style={{ margin: 8 }} variant="contained" color="primary" href={`${window.location.origin}/docs/api#operation/createEventUsingPOST`} target="_blank">Create Event API Docs</Button>
          <Button style={{ margin: 8 }} variant="contained" color="primary" href={`${window.location.origin}/docs/api#operation/createEventFromEventTemplateUsingPOST`} target="_blank">Create Event From Workflow API Docs</Button>
        </div>
        <Typography gutterBottom>
          Input Entity IDs
        </Typography>
        <Typography variant="caption" gutterBottom>
          {`
            Often, you will be required to provide IDs associated with various entities
            when interacting/invoking these APIs. To create an Event without an associated
            Workflow, you will be required to send in the ID of the starting Status, a
            list of Tag IDs to associate with the Event, and a key value map of Event
            Data Fields and their values to provide additional data for the Event. This is
            just one example, most of our APIs will require some input.
          `}
        </Typography>
      </div>
    </CardContent>
  </Card>
);

export default ApiDocumentationCardComponent;
